/* eslint-disable quotes */
import { openDB } from "./indexeddb.service";

const DB_NAME = "miniGuidesDB";
const DB_VERSION = 1;
const STORE = "miniguides";

// Opens/creates the DB and the "miniguides" store with primary key "id"
export function getMiniGuidesDB() {
  return openDB(DB_NAME, DB_VERSION, (db, oldV) => {
    if (oldV < 1) {
      db.createObjectStore(STORE, { keyPath: "id" });
    }
  });
}

export { STORE as MINIGUIDES_STORE };
